import React, { PureComponent } from "react";
import ReactWOW from 'react-wow';
import i18n from 'i18next'

class Judges extends PureComponent {
  render() {
    const msg = this.props.Message;
    return (
      <section id="judge">
        <div className="container">
          <div className="title-block">
            <h2>{i18n.t(msg.judge)}</h2>
          </div>
          <div className="judge-list">
            {
              msg.judgeData.map((item, index) => {
                return (
                  <ReactWOW animation="fadeInUp" delay="0.1s" key={index}>
                    <div className="judge-data">
                      <img className="icon" src="images/bullet.svg" alt="bullet point"/>
                      <div className="text-section">
                        <h4>{i18n.t(item.title)}</h4>
                        <ul>
                          {item.li.map(listItem =>
                            <li key={listItem}>{i18n.t(listItem)}</li>
                          )}
                        </ul>
                      </div>
                    </div>
                  </ReactWOW>
                )
              })
            }
          </div>
        </div>
      </section>
    )
  }
}

export default Judges;